module.exports = __webpack_public_path__ + "img/tryp-aeroporto-lisboa.03ed68cc.jpg";